module.exports = __webpack_public_path__ + "img/Autogenerationtestred.50caff0c.svg";